export enum FillSupport {
  ALLOW_PARTIAL,
  ALL_OR_NOTHING,
}

export namespace FillSupport {
  let elements = [FillSupport.ALLOW_PARTIAL, FillSupport.ALL_OR_NOTHING];
  let alias = "com.bcdfx.model.FillSupport";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
